import axios from "axios";
import React, { useState, useEffect, useContext, useTransition } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const ResetPassword = () => {
    const { apiURL, setLoginStatus, setToken } = useContext(ConfigContext);
    const navigate = useNavigate();
    const {t} = useTranslation();
    const dir = localStorage.getItem('dir');
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [loading, setLoading] = useState(false);
    const [messageType, setMessageType] = useState(0);
    const [responseMessage, setResponseMessage] = useState(true);
    const {reset_password_token} = useParams();
    const handleLogin = async(e) => {
        e.preventDefault();
        const { data } = await axios.post(
            `${apiURL}/Account/ResetPassword`,
            { password: password, reset_password_token: reset_password_token } 
          );
          
        
        if (data.success) { 
            setMessageType(1);
            setResponseMessage(data.message);
            setPassword("");
            setConfirmPassword("");
        }else{
            setMessageType(1);
            setResponseMessage(data.message);
            setLoading(false);
        }
    }
    return (
        <main className="main" style={{ direction: dir, textAlign: dir === 'rtl' ? 'right' : 'left' }}>
            <Helmet>
                <title>Reset Password - {t('site_name')}</title>
                <meta name="description" content={`Can't remember your password? Reset it easily with ${t('site_name')} and regain access to your account.`} />
                
                <meta name="robots" content="noindex, nofollow" />
                <meta property="og:title" content={`Forgot Your Password? - ${t('site_name')}`} />
                <meta property="og:description" content={`Reset your password securely on ${t('site_name')} and access your account in a few steps.`} />
                <meta property="og:url" content={`${t('site_url')}/Forget-Password`} />
                <meta property="og:type" content="website" />
                <meta property="og:image" content={`${t('site_url')}/static/images/forgot-password.png`} />
                
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`Forgot Your Password? - ${t('site_name')}`} />
                <meta name="twitter:description" content={`Having trouble logging in? Reset your password quickly on ${t('site_name')} and regain access to your account.`} />
                <meta name="twitter:image" content={`${t('site_url')}/static/images/forgot-password.png`} />

                <link rel="canonical" href={`${t('site_url')}/forgot-password`} />
            </Helmet>

            <div className="container login-container">
                <div className="row">
                    <div className="col-lg-12 mx-auto">
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="heading mb-1 mt-5">
                                    <h2 className="title">{t('reset_password')}</h2>
                                </div>
                                <form onSubmit={handleLogin}>
                                    <label htmlFor="login-password"> {t('password')} (<span className="required">*</span>) </label>
                                    <input type="password" className="form-input form-wide" id="password" name="password" placeholder="Enter your password" required value={password} onChange={(e) => setPassword(e.target.value)} />
                                   
                                    <br /> 

                                    <label htmlFor="login-password"> {t('confirm_password')} (<span className="required">*</span>) </label>
                                    <input type="password" className="form-input form-wide" id="confirm_password" name="confirm_password" placeholder="Enter confirm password" required value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                    <div style={{marginTop: '-10px'}}>
                                    {
                                        confirmPassword && password !== confirmPassword && <span style={{color: 'red'}}>{t('password_not_match')}</span>
                                    }
                                    </div>
                                    <br />
                                    
                                   
                                    {
                                        messageType === 1 &&
                                        <div className="alert alert-success">
                                         Password has been successfully reset
                                        </div>
                                    }

                                    
                                    {
                                         loading === false && password && confirmPassword && password === confirmPassword && password.length > 5? 
                                        <button type="submit" className="btn btn-dark btn-md w-100"> {t('reset_password')} </button>
                                        :<button type="button" disabled className="btn btn-dark btn-md w-100"> {t('reset_password')} </button>
                                    }
                                    <br />
                                   
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default ResetPassword;